import Button from "heroic-ui-library/dist/components/Button";
import { useState } from "react";
import Loading from "react-loading";
import { apiClient } from "../../api/api-client";
import Cookies from "js-cookie";

export default function LoginWithGoogle() {
  const [isLoading, setIsLoading] = useState(false);

  const callSSO = async () => {
    setIsLoading(true);
    try {
      let redirectPath = window.location.href + "parent_code/";

      if (Cookies.get("redirect") == "true") {
        redirectPath = "https://parent.heroicgameday.com/dashboard/";
      }

      const resp = await apiClient.getLoginLink(redirectPath);
      window.location.href = resp;

      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div className="flex items-center justify-center">
      {isLoading && <Loading type="spin" color="#002356" />}
      {!isLoading && (
        <Button
          className="submit-btn"
          label="Login With Google"
          btnType="green"
          onClick={callSSO}
        />
      )}
    </div>
  );
}
